import { CompanyReviewSummary } from "../Model/companyReviewsObjects";

export const COMPANY_REVIEW_SUMMARY = "COMPANY_REVIEW_SUMMARY";

const initialState = new CompanyReviewSummary(null, {});

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case COMPANY_REVIEW_SUMMARY:
            return action.payload;
        default:
            return state;
    }
}

const storeName = "companyReviewSummary";

const storeMapping = {[storeName]: reducer};

export const companyReviewSummarySelector = (state) => state[storeName];

export default storeMapping; 